var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['home-category', _setup.scrollClassComp],attrs:{"id":"home-category"}},[_c(_setup.WEventProcessor,{attrs:{"category-list":_setup.categoryListComp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }